var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var errors = require('../errors');

var importKey = require('./import');

var RSAKey = require('./key/rsa');

var ECKey = require('./key/ec');

var OKPKey = require('./key/okp');

var OctKey = require('./key/oct');

var generate = function generate(kty, crvOrSize, params) {
  var generatePrivate,
      _args = arguments;
  return _regeneratorRuntime.async(function generate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          generatePrivate = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;
          _context.t0 = kty;
          _context.next = _context.t0 === 'RSA' ? 4 : _context.t0 === 'EC' ? 10 : _context.t0 === 'OKP' ? 16 : _context.t0 === 'oct' ? 22 : 28;
          break;

        case 4:
          _context.t1 = importKey;
          _context.next = 7;
          return _regeneratorRuntime.awrap(RSAKey.generate(crvOrSize, generatePrivate));

        case 7:
          _context.t2 = _context.sent;
          _context.t3 = params;
          return _context.abrupt("return", (0, _context.t1)(_context.t2, _context.t3));

        case 10:
          _context.t4 = importKey;
          _context.next = 13;
          return _regeneratorRuntime.awrap(ECKey.generate(crvOrSize, generatePrivate));

        case 13:
          _context.t5 = _context.sent;
          _context.t6 = params;
          return _context.abrupt("return", (0, _context.t4)(_context.t5, _context.t6));

        case 16:
          _context.t7 = importKey;
          _context.next = 19;
          return _regeneratorRuntime.awrap(OKPKey.generate(crvOrSize, generatePrivate));

        case 19:
          _context.t8 = _context.sent;
          _context.t9 = params;
          return _context.abrupt("return", (0, _context.t7)(_context.t8, _context.t9));

        case 22:
          _context.t10 = importKey;
          _context.next = 25;
          return _regeneratorRuntime.awrap(OctKey.generate(crvOrSize, generatePrivate));

        case 25:
          _context.t11 = _context.sent;
          _context.t12 = params;
          return _context.abrupt("return", (0, _context.t10)(_context.t11, _context.t12));

        case 28:
          throw new errors.JOSENotSupported("unsupported key type: ".concat(kty));

        case 29:
        case "end":
          return _context.stop();
      }
    }
  });
};

var generateSync = function generateSync(kty, crvOrSize, params) {
  var generatePrivate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  switch (kty) {
    case 'RSA':
      return importKey(RSAKey.generateSync(crvOrSize, generatePrivate), params);

    case 'EC':
      return importKey(ECKey.generateSync(crvOrSize, generatePrivate), params);

    case 'OKP':
      return importKey(OKPKey.generateSync(crvOrSize, generatePrivate), params);

    case 'oct':
      return importKey(OctKey.generateSync(crvOrSize, generatePrivate), params);

    default:
      throw new errors.JOSENotSupported("unsupported key type: ".concat(kty));
  }
};

module.exports.generate = generate;
module.exports.generateSync = generateSync;